import 'react';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';
import { decorateComponent } from '../../../documentComponents/decorateComponent.js';
import { AccordionContent as AccordionContent$1 } from './AccordionContent.js';
import { jsx } from '@emotion/react';

var AccordionContent = decorateComponent(AccordionContent$1, 'block', {
  id: 'accordionContent',
  label: '아코디언 내용',
  allowedParent: ['accordion'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: function renderIcon() {
    return jsx(BsCardText, null);
  }
});

export { AccordionContent as default };
//# sourceMappingURL=index.js.map
